import { useQuery } from '@tanstack/react-query';

import { STALE_TIME_5_MIN } from '~/domains/common/constants/query';
import type { PromotedContestCarousel } from '~/services/marketing/promoted-contests.schema';
import { getPromotedContestsCollection } from '~/services/marketing/promoted-contests.service.api';

import { CondensedCarouselsQueryKeys, type HomeCollectionSlug } from '../constants/query';

const NO_CAROUSELS: PromotedContestCarousel[] = [];

export const usePromotedContestsCollection = (
  slug: HomeCollectionSlug
): { carousels: PromotedContestCarousel[]; isLoading: boolean; isError: boolean } => {
  const { data, isLoading, isError } = useQuery({
    queryKey: CondensedCarouselsQueryKeys.COLLECTION(slug),
    queryFn: ({ signal }) => getPromotedContestsCollection(slug, signal),
    staleTime: STALE_TIME_5_MIN,
  });

  return { carousels: data ?? NO_CAROUSELS, isLoading, isError };
};
